import {Component, Input, OnInit, Optional} from '@angular/core';
import {FormControl, FormGroup,} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from '../../../../infrastructure/decorators/auto-unsubscribe.decorator';
import {VendorFilterResult} from '../../model/vendor-filter-result';
import { TramsDataSourceModel } from '../../../payments/models/trams-data-source';
import { HttpClient } from '@angular/common/http';

@AutoUnsubscribe()
@Component({
    selector: 'vendors-filter-modal',
    templateUrl: './vendors-filter-modal.component.html',
    standalone: false
})
export class VendorsFilterModalComponent implements OnInit {
  @Input() config!: VendorFilterResult;

  constructor(
    @Optional() public dialogRef: MatDialogRef<VendorsFilterModalComponent>,
    private http: HttpClient
  ) {}

  form: FormGroup = new FormGroup({
    vendorName: new FormControl(null),
    vendorCity: new FormControl(null),
    vendorCountry: new FormControl(null),
    dataSource: new FormControl(null)
  });

  public datasources: TramsDataSourceModel[] = [];

  handleVendorFiltersFormCloseEvent() {
    if (!this.dialogRef) {
      return;
    }
    this.dialogRef.close(null);
  }

  protected get showDataSourceClearIcon() {
    return !!this.form.controls['dataSource'].value;
  }

  ngOnInit() {
    const {vendorName, vendorCity, vendorCountry, dataSource} = this.config ?? {};
    this.form.patchValue({
      vendorName, vendorCity, vendorCountry, dataSource
    });
    this.http.get<TramsDataSourceModel[]>('dbov2/trams-data-source').subscribe(
      (data) => {
        this.datasources = data;
      },
      (error) => {
        console.error('Failed to fetch datasources', error);
      }
    );
  }

  applyVendorFilters() {
    const formValues = this.form.value;
    this.config = {
      vendorName: formValues.vendorName?.trim(),
      vendorCity: formValues.vendorCity?.trim(),
      vendorCountry: formValues.vendorCountry?.trim(),
      dataSource: formValues.dataSource
    };
    
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    }
    else if (this.dialogRef) {
      this.dialogRef.close(this.config);
    }
  }

  public clearVendorFilters(propertyName: string): void {
    if (propertyName === 'all') {
      this.config = {} as VendorFilterResult;
      this.form.reset();
    }else{
      this.form.get(propertyName)?.setValue(null);
      
      const temp = { ...this.config };
      delete temp[propertyName as keyof VendorFilterResult];
      this.config = temp;
    }
  }
}
